import React from 'react';
import PropTypes from 'prop-types';
import buttonLabels from 'utils/ButtonLabels';
import calculate from 'logics/calculate';
import CalculatorButton from './CalculatorButton';

const Keypad = ({ setCalObj, calObj }) => {
  const handleButtonClick = (label) => {
    const newCalcObj = calculate(calObj, label);
    setCalObj(newCalcObj);
  };
  return (
    <div className="calculator__keypad">
      {buttonLabels.map((label) => (
        <CalculatorButton
          key={label}
          label={label}
          handleButtonClick={handleButtonClick}
        />
      ))}
    </div>
  );
};

Keypad.propTypes = {
  setCalObj: PropTypes.func.isRequired,
  calObj: PropTypes.shape({
    total: PropTypes.string,
    next: PropTypes.string,
    operation: PropTypes.string,
  }).isRequired,
};

export default Keypad;
